import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { Delete } from "@element-plus/icons-vue";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { $t } from "../plugins/i18n";
export default {
  name: "authorityManagement",
  data: function data() {
    return {
      Delete: Delete,
      tableData: null,
      dialogVisible: false,
      isHavePermission: false,
      isUseKeychain: false,
      isloadEnd: false,
      acitveKey: "",
      isError: false,
      errorMessage: "",
      isLoading: false,
      userName: "",
      isLogin: false,
      currentCheckUserName: "",
      removeUserName: ""
    };
  },
  methods: {
    removeAuthorize: function removeAuthorize(userName) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.removeUserName = userName;
                _this.dialogVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    confirmAuthorize: function confirmAuthorize() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _this2.isLoading = true;
                _context2.next = 4;
                return dsteem.removeAuthorize(_this2.acitveKey, _this2.removeUserName);

              case 4:
                result = _context2.sent;
                _this2.isLoading = false;

                if (!(result.code != 0)) {
                  _context2.next = 10;
                  break;
                }

                _this2.isError = true;
                _this2.errorMessage = result.message;
                return _context2.abrupt("return");

              case 10:
                _this2.isHavePermission = true;
                _this2.dialogVisible = false;
                ElMessage({
                  message: _this2.$t("success.removeAuthorizeSuccess"),
                  type: "success"
                });
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                _this2.isError = true;
                _this2.errorMessage = _context2.t0.message;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 15]]);
      }))();
    },
    onCheck: function onCheck() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var tempAccount;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.userName == "")) {
                  _context3.next = 3;
                  break;
                }

                ElMessage({
                  message: _this3.$t("error.haveNullUser"),
                  type: "error"
                });
                return _context3.abrupt("return");

              case 3:
                _this3.currentCheckUserName = _this3.userName;
                _context3.next = 6;
                return getAccount(_this3.userName);

              case 6:
                tempAccount = _context3.sent;
                _this3.tableData = tempAccount.posting.account_auths;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this4.loginData = extractLoginData();

              if (!_this4.loginData) {
                _context4.next = 10;
                break;
              }

              _this4.isLogin = true;
              _this4.currentCheckUserName = _this4.loginData[0];
              _this4.currentUserName = _this4.loginData[0];
              _this4.isUseKeychain = _this4.loginData[4] == "true";
              _context4.next = 8;
              return getAccount(_this4.currentUserName);

            case 8:
              _this4.account = _context4.sent;
              _this4.tableData = _this4.account.posting.account_auths;

            case 10:
              _this4.isloadEnd = true;

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};